// uploads

import * as bootstrap from 'bootstrap';
import axios from 'smg/axios';
import * as clipboard from 'smg/clipboard';
import * as session from 'smg/customer-api/session';
import * as formatting from 'smg/formatting';
import * as html from 'smg/html';
import * as mime from 'smg/mime';
import Modal from 'smg/modal';
import * as models from 'smg/models';
import { RemToPx } from 'smg/rem';
import * as column from 'smg/table/column';
import * as tableLib from 'smg/table/table';
import * as toast from 'smg/toast';
import * as uploads from 'smg/uploads';
import { Relref } from '../hugo';
import * as search from '../search';

declare interface myWindow extends Window {
    readonly cloudFront: string;
}
declare const window: myWindow;

declare interface resp {
    uploads: models.Upload[];
}

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    type r = models.Upload;
    type c = keyof r;
    type d = '';

    class table extends tableLib.Table<r, c, d> {
        RowHeight = RemToPx(parseFloat(getComputedStyle(document.querySelector('.iap-table') as HTMLElement).getPropertyValue('--row-height'))) + 1;

        RowsPerPage = 100;

        GetRowsFromResponse = (d: resp) => d.uploads;

        constructor() {
            super('/uploads', search.Input as HTMLInputElement, search.Form as HTMLFormElement);

            this.AddColumns(
                new column.ColumnID(),
                new column.Column({
                    name: 'Name',
                    width: 15,
                    minWidth: '5rem',
                    columns: 'name',
                    draw: (td, r) => {
                        if (!r.key) {
                            return;
                        }

                        const url = `${window.cloudFront}/${r.key}`;

                        const a = document.createElement('a');
                        a.href = url;
                        if (r.mime && mime.WebSafeMime(r.mime)) {
                            a.setAttribute('data-fancybox', String(r.id));
                        }
                        a.textContent = r.name || 'File';

                        td.appendChild(a);
                    },
                    text: r => r.name || 'File',
                }),
                new column.Column({
                    name: 'URL',
                    width: 10,
                    columns: ['key', 'mime', 'name'],
                    draw: (td, r) => {
                        if (!r.key) {
                            return;
                        }

                        const url = `${window.cloudFront}/${r.key}`;

                        const a = document.createElement('a');
                        a.href = url;
                        if (r.mime && mime.WebSafeMime(r.mime)) {
                            a.setAttribute('data-fancybox', String(r.id));
                        }
                        a.textContent = url;

                        td.appendChild(a);
                    },
                    text: r => `${window.cloudFront}/${r.key || ''}`,
                    images: r => {
                        if (!r.key) {
                            return [];
                        }
                        if (!r.mime || !mime.WebSafeMime(r.mime)) {
                            return [];
                        }

                        const url = `${window.cloudFront}/${r.key}`;
                        return [{
                            name: r.name || '',
                            src: url,
                        }];
                    },
                }),
                new column.Column({
                    name: 'Thumbnail',
                    width: '5.5rem',
                    columns: ['key', 'mime', 'name'],
                    headingHTML: '',
                    draw: (td, r) => {
                        if (!r.key) {
                            return;
                        }
                        if (!r.mime || !mime.WebSafeMime(r.mime)) {
                            return;
                        }

                        const url = `${window.cloudFront}/${r.key}`;

                        const a = document.createElement('a');
                        a.href = url;
                        a.setAttribute('data-fancybox', 'uploads');

                        const img = document.createElement('img');
                        img.src = url;
                        img.alt = r.name || '';
                        img.title = r.name || '';
                        img.style.maxWidth = '5rem';
                        img.style.maxHeight = '5rem';

                        a.appendChild(img);

                        td.appendChild(a);
                    },
                    text: () => '',
                }),
                new column.ColumnNumber({
                    name: 'Size',
                    width: '8rem',
                    column: 'size',
                    sort: {
                        column: 'size',
                    },
                    text: r => formatting.HumanFileSize(r.size || 0),
                }),
                new column.Column({
                    name: 'Mime',
                    width: '10rem',
                    columns: 'mime',
                    draw: (td, r) => td.textContent = r.mime || '',
                    visible: false,
                }),
                new column.ColumnDateTime({
                    sortDirection: 'desc',
                }),
                new column.Column({
                    name: 'Actions',
                    headingHTML: '',
                    width: '11rem',
                    columns: ['key', 'name'],
                    draw: (td, r) => {
                        const download = html.FromString(`
                        <a class="btn btn-primary text-white mb-2" href="${html.Escape(`${window.cloudFront}/${r.key || ''}`)}" download="${html.Escape(r.name || 'File')}">
                            <i class="fas fa-file-download"></i> Download
                        </a>`);
                        td.appendChild(download);

                        const copyLink = html.FromString('<button class="btn btn-outline-secondary mb-2"><i class="fas fa-link"></i> Copy Link</button>');
                        td.appendChild(copyLink);
                        copyLink.addEventListener('click', () => {
                            clipboard.Copy(`${window.cloudFront}/${r.key || ''}`);
                            const t = new bootstrap.Tooltip(copyLink, {
                                title: 'Copied!',
                                trigger: 'manual',

                            });
                            t.show();
                            setTimeout(() => t.dispose(), 2000);
                        });
                    },
                    text: () => '',
                }),
            );

            this.EnableAutoUpdating(10 * 60 * 1000);
        }
    }

    const t = new table();

    void t.Build();

    const newButton = document.querySelector('#new-upload') as HTMLButtonElement;
    newButton.addEventListener('click', () => {
        const body = (document.querySelector('#modal-upload-template') as HTMLTemplateElement).content.cloneNode(true) as DocumentFragment;

        const uploadsLabel = body.querySelector('#modal-uploads') as HTMLLabelElement;
        const spinner = uploadsLabel.querySelector('.spinner-border') as HTMLElement;

        const m = new Modal({
            outsideClosable: false,
            title: 'Upload files to your account',
            body,
            onSubmit: async () => {
                const uploadIDs = u.GetUploadIDs();
                return axios.patch('/uploads/keep', {
                    'uploadIDs': uploadIDs,
                }).then(() => {
                    void t.Send();
                    toast.Success(`File${uploadIDs.length === 1 ? '' : 's'} have been uploaded!`);
                });
            },
        });

        const u: uploads.Uploader = new uploads.Uploader(uploadsLabel, {
            confirmBtn: m.Element.querySelector('[type="submit"]') as HTMLButtonElement,
            thumbnails: document.querySelector('#modal-uploads-thumbnails') as HTMLElement,
            start: () => spinner.classList.remove('d-none'),
            stop: () => spinner.classList.add('d-none'),
        });
    });
}